import React from 'react';

import { RiskIcon } from '../common/RiskIcon';
import {
	FullWarningEvent,
	impactLabel,
	likelihoodLabel,
	seriousnessLabel,
	WarningEventStatus,
} from '../../restapi/types';
import { DocFragment } from '../common/DocFragment';
import { ApprovedMark } from '../common/ApprovedMark';
import { CommentsMark } from '../common/comments/CommentsMark';
import { Checkbox } from '@wfp/ui';


interface Props {
	event: FullWarningEvent;
	selected: boolean;
	onToggleSelection: () => void;
}

export function DocSection({event, selected, onToggleSelection}: Props) {
	return <div className="section">
		<div className="fright center">
			<ApprovedMark event={event}/>
			<CommentsMark active event={event}/>
		</div>
		<h2>
			{(event.status === WarningEventStatus.approved) ?
				<>{event.warning.title}</>
				:
				<Checkbox
					id={`doc-section-${event.id}`}
					name="select"
					labelText={event.warning.title}
					checked={selected}
					onChange={onToggleSelection}
				/>
			}
		</h2>
		<div>{event.warning.risks.map(
			r => <RiskIcon key={r} risk={r} seriousness={event.seriousness}/>,
		)} {event.warning.description}</div>
		<p>Likelihood: {likelihoodLabel[event.likelihood]} &mdash;
			Impact: {impactLabel[event.impact]} &mdash;
			Seriousness: {seriousnessLabel[event.seriousness]}</p>

		<DocFragment title="Key Takeaway"
					 content={event.warning.keyTakeaway}/>
		<DocFragment title="Background"
					 content={event.warning.background}/>
		<DocFragment title="Outlook"
					 content={event.warning.outlook}/>
		<DocFragment title="Indicators to watch"
					 content={event.warning.indicators}/>

	</div>;
}
